import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import ListActions from '../../../../redux/List/actions';

const {
    addAccount,
} = ListActions;

export function useAccount({ form }) {
    const dispatch = useDispatch();

    const onAccountCreate = useCallback(account => { // Reload account list.
        dispatch(
            addAccount(account),
        );
        form.setFieldsValue({ account_id: account.id });
    }, [dispatch, form]);

    const onAccount2Create = useCallback(account => { // Reload account list.
        dispatch(
            addAccount(account),
        );
        form.setFieldsValue({ account2_id: account.id });
    }, [dispatch, form]);

    return {
        onAccountCreate,
        onAccount2Create,
    };
}
